import { useState, useCallback, useEffect } from "react";
import { UnifiedRequestType } from "../../services/admin/types/unifiedRequests.types";

const STORAGE_KEY_TYPE = "adminUnifiedRequestsFilterType";
const STORAGE_KEY_STATUS = "adminUnifiedRequestsFilterStatus";

const validTypes = Object.values(UnifiedRequestType) as string[];

const getPersistedType = (): UnifiedRequestType | null => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY_TYPE);
    if (saved === null || saved === "null") return null;
    if (validTypes.includes(saved)) {
      return saved as UnifiedRequestType;
    }
    return null;
  } catch {
    return null;
  }
};

const getPersistedStatus = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY_STATUS) || "";
  } catch {
    return "";
  }
};

export const useUnifiedRequestFilters = (onFilterChange?: () => void) => {
  const [requestType, setRequestTypeState] = useState<UnifiedRequestType | null>(
    getPersistedType
  );
  const [status, setStatusState] = useState<string>(getPersistedStatus);

  const setRequestType = useCallback(
    (type: UnifiedRequestType | null) => {
      setRequestTypeState(type);
      onFilterChange?.();
    },
    [onFilterChange]
  );

  const setStatus = useCallback(
    (newStatus: string) => {
      setStatusState(newStatus);
      onFilterChange?.();
    },
    [onFilterChange]
  );

  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY_TYPE,
        requestType === null ? "null" : requestType.toString()
      );
    } catch {
      // Ignore localStorage errors
    }
  }, [requestType]);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY_STATUS, status);
    } catch {
      // Ignore localStorage errors
    }
  }, [status]);

  return {
    requestType,
    setRequestType,
    status,
    setStatus,
  };
};
